"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultClassUtil_1 = __importDefault(require("modules/classManager/DefaultClassUtil"));
const drippingFormUtil_1 = __importDefault(require("./drippingFormUtil"));
class DrippingResponseUtil {
    getNormalizedItems(drippingResponse = []) {
        const drippings = drippingResponse.map((item) => {
            const dripping = {
                id: item.id,
                key: drippingFormUtil_1.default.generateKey(),
                allClasses: item.classes.length === 0,
                classes: item.classes.map((item) => ({
                    ...item,
                    name: DefaultClassUtil_1.default.getName(item.name)
                })),
                releaseDate: this.getReleaseDate(item.liberation),
                releaseDays: this.getReleaseByDay(item.liberation),
                expirationDays: this.getExpirationDays(item.expiration),
                pageId: this.getPageId(item.liberation)
            };
            return dripping;
        });
        return drippings;
    }
    getReleaseDate(liberation) {
        if (liberation &&
            liberation.type === 'BY_DATE' &&
            liberation.liberationDate) {
            return liberation.liberationDate;
        }
        return null;
    }
    getReleaseByDay(liberation) {
        if (liberation &&
            liberation.type === 'BY_DAYS' &&
            liberation.liberationDays) {
            return liberation.liberationDays;
        }
        return null;
    }
    getPageId(liberation) {
        if (liberation && liberation.type === 'BY_QUIZ' && liberation.pageId) {
            return liberation.pageId;
        }
        return null;
    }
    getExpirationDays(expiration) {
        if (expiration && expiration.type === 'BY_DAYS') {
            return expiration.durationDays;
        }
        return null;
    }
}
exports.default = new DrippingResponseUtil();
